
export const PageType = {
  REGULAR: 'REGULAR',
  ARTICLE: 'ARTICLE',
  BREADCRUMB: 'BREADCRUMB'
}